import React, { useCallback } from 'react'
import styled from 'styled-components'

import ProductLiteratureGroup from 'pages/shared/ProductLiteratureGroup'
import Spinner from 'components/Spinner'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import { ProductLiterature } from 'types/ProductLiterature'
import EmptyStatePanel from 'pages/shared/EmptyStatePanel'
import { DEFAULT_NO_RESULTS_MESSAGE } from 'helpers/constants'

type Props = {
  searchedValue?: string
  productLiterature: ProductLiterature[]
  isProductLiteratureLoaded: boolean
  serverError: boolean
}

const ProductLiteratureSearch = ({ searchedValue, productLiterature, isProductLiteratureLoaded, serverError }: Props) => {
  const renderContent = useCallback(() => {
    const renderEmptyStatePanel = (showNoResults: boolean) => {
      return (
        <EmptyStatePanel
          headingText="Product Literature"
          descriptionText={'When searching, you must enter at least the first four characters of the model number such as “TCONT”. If the full model number does not return any results, remove a few characters from the end and search again.'}
          canShowNoResultsBanner={showNoResults}
          noResultsHeadingText={DEFAULT_NO_RESULTS_MESSAGE.noResultsHeadingText}
          noResultsDescriptionText={DEFAULT_NO_RESULTS_MESSAGE.noResultsDescriptionText}
        />
      )
    }

    if (!searchedValue) {
      return renderEmptyStatePanel(false)
    }

    if (searchedValue.length < 4) {
      return renderEmptyStatePanel(true)
    }

    if (!isProductLiteratureLoaded) {
      return <Spinner variant="page" />
    }

    if (serverError || productLiterature.length === 0) {
      return renderEmptyStatePanel(true)
    }

    return (
      <>
        <S.TabPanelTitle>Product Literature</S.TabPanelTitle>
        {productLiterature.map((group) => (
          <ProductLiteratureGroup page={'search'} key={group.literatureType} group={group} />
        ))}
      </>
    )
  }, [searchedValue, isProductLiteratureLoaded, serverError, productLiterature])

  return (
    <S.Container>
      {renderContent()}
    </S.Container>
  )
}

export default ProductLiteratureSearch

const S = {
  Container: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
  `,
  TabPanelTitle: styled.div`
    margin-left: 20px;
    margin-top: 20px;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 20px;
    color: ${color('primaryText')};

    @media ${screenSize.medium} {
     font-size: 20px;
  }
  `
}
